import React, { useState, useEffect } from 'react';
import { MANDATORY_DISCOUNT_TYPES, MANDATORY_DISCOUNT_LABELS, calculateMandatoryDiscount } from '../enums/mandatory_discounts.js';

const ReservationForm = ({ reservationDetails, onCancel, onProceed }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [contact, setContact] = useState('');
    const [notes, setNotes] = useState('');
    const [mandatoryDiscountType, setMandatoryDiscountType] = useState(MANDATORY_DISCOUNT_TYPES.NONE);
    const [mandatoryDiscountIdNumber, setMandatoryDiscountIdNumber] = useState('');

    // Calculate discount and final amount
    const discountCalculation = calculateMandatoryDiscount(reservationDetails.totalAmount, mandatoryDiscountType);

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Validate mandatory discount
        if (mandatoryDiscountType !== MANDATORY_DISCOUNT_TYPES.NONE && !mandatoryDiscountIdNumber.trim()) {
            alert('Please enter a valid ID number for the mandatory discount.');
            return;
        }

        onProceed({ 
            name, 
            email,
            contact,
            notes,
            mandatory_discount_type: mandatoryDiscountType,
            mandatory_discount_id_number: mandatoryDiscountIdNumber.trim() || null
        });
    };

    const handleDiscountTypeChange = (e) => {
        const newType = e.target.value;
        setMandatoryDiscountType(newType);
        
        // Clear ID number if no discount is selected
        if (newType === MANDATORY_DISCOUNT_TYPES.NONE) {
            setMandatoryDiscountIdNumber('');
        }
    };

    return (
        <div className="reservation-form">
            <h2>Reservation Details</h2>
            <div className="reservation-summary">
                <p><strong>Adults:</strong> {reservationDetails.adults}</p>
                <p><strong>Kids:</strong> {reservationDetails.kids}</p>
                <p><strong>Check-in:</strong> {reservationDetails.checkIn}</p>
                <p><strong>Check-out:</strong> {reservationDetails.checkOut}</p>
                <p><strong>Base Amount:</strong> ₱{reservationDetails.totalAmount.toLocaleString()}</p>
                
                {mandatoryDiscountType !== MANDATORY_DISCOUNT_TYPES.NONE && (
                    <div className="discount-breakdown">
                        <p><strong>Discount Type:</strong> {MANDATORY_DISCOUNT_LABELS[mandatoryDiscountType]}</p>
                        <p><strong>20% Discount:</strong> -₱{discountCalculation.discountAmount.toLocaleString()}</p>
                        <p><strong>VAT Exemption:</strong> -₱{discountCalculation.vatExemptAmount.toLocaleString()}</p>
                        <p><strong>Total Savings:</strong> -₱{discountCalculation.totalSavings.toLocaleString()}</p>
                        <hr />
                    </div>
                )}
                
                <p className="final-amount"><strong>Final Amount: ₱{discountCalculation.finalAmount.toLocaleString()}</strong></p>
            </div>

            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="name">Guest Name *:</label>
                    <input
                        type="text"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        placeholder="Enter guest full name"
                    />
                </div>
                
                <div className="form-group">
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter email address"
                    />
                </div>
                
                <div className="form-group">
                    <label htmlFor="contact">Contact Number:</label>
                    <input
                        type="tel"
                        id="contact"
                        value={contact}
                        onChange={(e) => setContact(e.target.value)}
                        placeholder="Enter contact number"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="mandatoryDiscount">Mandatory Discount (Philippine Law):</label>
                    <select
                        id="mandatoryDiscount"
                        value={mandatoryDiscountType}
                        onChange={handleDiscountTypeChange}
                    >
                        <option value={MANDATORY_DISCOUNT_TYPES.NONE}>{MANDATORY_DISCOUNT_LABELS.NONE}</option>
                        <option value={MANDATORY_DISCOUNT_TYPES.SENIOR}>{MANDATORY_DISCOUNT_LABELS.SENIOR}</option>
                        <option value={MANDATORY_DISCOUNT_TYPES.PWD}>{MANDATORY_DISCOUNT_LABELS.PWD}</option>
                    </select>
                </div>

                {mandatoryDiscountType !== MANDATORY_DISCOUNT_TYPES.NONE && (
                    <div className="form-group mandatory-id-group">
                        <label htmlFor="mandatoryIdNumber">
                            {mandatoryDiscountType === MANDATORY_DISCOUNT_TYPES.SENIOR ? 'Senior Citizen ID Number' : 'PWD ID Number'} *:
                        </label>
                        <input
                            type="text"
                            id="mandatoryIdNumber"
                            value={mandatoryDiscountIdNumber}
                            onChange={(e) => setMandatoryDiscountIdNumber(e.target.value)}
                            required={mandatoryDiscountType !== MANDATORY_DISCOUNT_TYPES.NONE}
                            placeholder={`Enter valid ${mandatoryDiscountType === MANDATORY_DISCOUNT_TYPES.SENIOR ? 'Senior Citizen' : 'PWD'} ID number`}
                        />
                        <small className="id-note">
                            ⚠️ Valid ID must be presented upon check-in to avail this discount.
                        </small>
                    </div>
                )}

                <div className="form-group">
                    <label htmlFor="notes">Customer Notes:</label>
                    <textarea
                        id="notes"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        placeholder="Enter any special requests or notes..."
                    />
                </div>
                
                <div className="buttons">
                    <button type="button" onClick={onCancel} className="btn-cancel">Cancel</button>
                    <button type="submit" className="btn-proceed">
                        Proceed with Reservation (₱{discountCalculation.finalAmount.toLocaleString()})
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ReservationForm;